import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getDefaultDisposalType from 'mini-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { lazyDeleteConversation, lazyDeleteItemFromReadingPane } from 'mini-mail-triage-actions';
import { TriageActionSource } from 'mini-mail-triage-actions/lib/schema/TriageActionSource';

/**
 * Deletes the item or entire conversation (including conversation nodes) with conversation dialog and closes the reading pane
 */
export const deleteFromReadingPane = (
    shouldSupportUndoAction?: boolean,
    onReadingPaneClose?: () => void,
    customSelectedId?: string,
    shouldIssueDeleteServiceCall?: boolean
) => {
    const { selectedId } = getMailStore().mailModule;
    const overrideSelectedId = customSelectedId ?? selectedId;
    const currentTableView = getCurrentSelectedTableView();
    if (isItemView(currentTableView)) {
        lazyDeleteItemFromReadingPane({
            itemId: overrideSelectedId,
            disposalType: getDefaultDisposalType(overrideSelectedId),
            source: 'Item_View',
            shouldSupportUndoAction,
            onReadingPaneClose,
            shouldIssueDeleteServiceCall: shouldIssueDeleteServiceCall,
        });
    } else {
        const conversationItemParts = getMailStore().conversations.get(overrideSelectedId);
        const noOfItemsInConversation = conversationItemParts?.conversationNodeIds?.length || 0;
        lazyDeleteConversation({
            conversationId: overrideSelectedId,
            originalTableViewId: currentTableView?.id,
            noOfItemsInConversation,
            sourceView: TriageActionSource.ReadingPane,
            shouldSupportUndoAction,
            onReadingPaneClose,
            shouldIssueDeleteServiceCall: shouldIssueDeleteServiceCall,
        });
    }
};
